import { css } from '@emotion/react';
import { useState } from 'react';
import t from 'react-translate';
import PillButton from 'athena/components/pill-button';
import { gray6, white } from 'styles/global_defaults/colors';
import { standardSpacing, threeQuartersSpacing } from 'styles/global_defaults/scaffolding';
import DataDownloads from './data-downloads';
import ProgramAnalytics from './program-analytics';
import { config } from '@config/pendo.config.json';


enum ReportingTab {
  DATA_DOWNLOADS = 'data-downloads',
  ANALYTICS = 'analytics',
}

type ReportingProps = {
  scrollEnabled: boolean;
  onScroll: React.ComponentProps<'div'>['onScroll'];
};

const Reporting = ({
  scrollEnabled,
  onScroll,
}: ReportingProps) => {
  const styles = css`
    margin: -${standardSpacing}px;

    overflow-y: ${scrollEnabled ? 'auto' : 'hidden'};

    .sub-tabs {
      position: sticky;
      top: 0;
      background-color: ${white};
      z-index: 10;

      gap: ${threeQuartersSpacing}px;
      border-bottom: 1px solid ${gray6};
    }
  `;

  const [currentTab, setCurrentTab] = useState<ReportingTab>(ReportingTab.ANALYTICS);

  return (
    <div css={styles} onScroll={onScroll}>
      <div className='sub-tabs d-flex flex-row flex-wrap p-4'>
        <PillButton
          text={t.MENTORING_PROGRAMS.REPORTING.ANALYTICS()}
          selected={currentTab === ReportingTab.ANALYTICS}
          onClick={() => setCurrentTab(ReportingTab.ANALYTICS)}
          dataQa={config.pendo.athena.mentorshipProgram.reporting.analyticsTab}
        />
        <PillButton
          text={t.MENTORING_PROGRAMS.REPORTING.DATA_DOWNLOADS()}
          selected={currentTab === ReportingTab.DATA_DOWNLOADS}
          onClick={() => setCurrentTab(ReportingTab.DATA_DOWNLOADS)}
          dataQa={config.pendo.athena.mentorshipProgram.reporting.dataDownloadsTab}
        />
      </div>
      <div className='p-4'>
        {currentTab === ReportingTab.DATA_DOWNLOADS && <DataDownloads />}
        {currentTab === ReportingTab.ANALYTICS && <ProgramAnalytics />}
      </div>
    </div>
  );
};


export default Reporting;
